import { Logger, LogLevel } from '@web-publish-id/logger'
import { getPaymentMethodList, getPaymentInitConfig, getPaymentExchangeRate } from '@web-publish-id/payment-shared/apis/payment'

import { GetPaymentMethodListParams, PaymentComponentCreateOptions, PaymentInitConfiguration } from './types'
import PaymentComponent from './payment/payment'
import { injectClientId, injectSecretConfig } from '@web-publish-id/shared/config'
import { bizApiWrapper } from '@web-publish-id/shared/http'

const signSecret = {
  key: import.meta.env.VITE_SIGN_SECRET_KEY,
  publicKey: import.meta.env.VITE_SIGN_SECRET_PUBLIC_KEY,
}

export class PaymentComponentCore {
  private logger!: Logger

  inited: boolean = false
  configuration: PaymentInitConfiguration

  /** Adyen配置 */
  adyenConfig: any = {}

  constructor() {
    this.logger = new Logger({
      prefix: 'PaymentComponent',
      level: import.meta.env.PROD ? LogLevel.INFO : LogLevel.DEBUG,
    })
  }

  /**
   * 初始化
   */
  async init(config: PaymentInitConfiguration) {
    const { client_id, language } = config
    if (!client_id) {
      throw new Error('client_id is required')
    }

    injectClientId(client_id)
    injectSecretConfig(signSecret)

    this.configuration = { ...config }

    // 获取初始化配置
    await this.getInitConfig()

    this.inited = true

    this.logger.info('payment init', config)
  }

  /**
   * 获取支付方式列表
   */
  async getPaymentMethodList(params: GetPaymentMethodListParams) {
    this.checkInited()

    const { country_code, business_type, sys_order_id } = params
    const res = await bizApiWrapper(getPaymentMethodList({ country_code, business_type, sys_order_id }))

    return res
  }

  /** 获取订单参考汇率，返回格式与其他 SDK 请求一致。 */
  getExchangeRate(params: { sys_order_id: string }, options?: { signal?: AbortSignal }) {
    this.checkInited()
    return bizApiWrapper(getPaymentExchangeRate(params, options?.signal))
  }

  /**
   * 创建支付组件
   */
  createPayment(config: PaymentComponentCreateOptions) {
    this.checkInited()

    // 创建支付组件
    const payment = new PaymentComponent(this, config)

    return payment
  }

  // 检查是否初始化
  private checkInited() {
    if (!this.inited) {
      throw new Error('PaymentComponent not initialized')
    }
  }

  // 初始化配置
  private async getInitConfig() {
    const res = await getPaymentInitConfig()
    const list = res.payment_channel_config_list
    if (!list?.length) return

    // 遍历配置
    list.forEach((item) => {
      const { payment_channel_type, config } = item
      if (!config) return
      let _config
      try {
        _config = JSON.parse(config)
      } catch (error) {
        return
      }

      if (payment_channel_type === 1) {
        this.adyenConfig = _config
      }
    })
  }
}

export default PaymentComponentCore
